import { z } from 'zod';

import { isUploadedCreativeType } from './enums.js';

/**
 * YAYINDA AI İÇERİK ETİKETİ — tek okuyucu (Dalga 5, 2 Eki 2026).
 *
 * Plan §2.6: "uygunsuz olan uyumlu sürümüne yeniden yazılır; yayında AI içerik
 * etiketi bayrağı taşınır". Prodüksiyon teslimleri bayrağı kreatifin KENDİSİNDE
 * taşıyor (`Creative.inputParams.aiContentLabel = { required: true, reason }`,
 * worker teslim yazıcısı) — prodüksiyon satırı silinse de kaybolmaz. Yayın
 * yolları (TikTok AIGC beyanı `aigc_disclosure_type`, Meta "AI info", Google)
 * bayrağı BURADAN okur; kural iki yerde ayrı yazılırsa biri bir gün AI
 * üretimini "kullanıcının kendi dosyası" sayar.
 *
 * Karar sırası (`aiContentLabelOf`):
 *   1. `inputParams.aiContentLabel.required === true` → gerekli (gerekçesiyle)
 *   2. prodüksiyon teslimi (`productionId` dolu) → gerekli
 *   3. üretilmiş tip (yükleme DEĞİL: AD_IMAGE, PRODUCT_VIDEO, UGC_VIDEO,
 *      IMPROVED, RESIZED, AD_VIDEO) → gerekli
 *   4. kullanıcının kendi yüklemesi (UPLOADED_IMAGE / UPLOADED_VIDEO) → gerekmez
 * `required: false` yalnız 4. dalda — açık bir "beyan etme" isteği AI
 * üretimini ezemez (TikTok `aigcDisclosureType` ile aynı ilke).
 */
export const AI_CONTENT_LABEL_KEY = 'aiContentLabel';

/// Gerekçe yazılmamış AI teslimin varsayılan gerekçesi.
export const AI_CONTENT_LABEL_DEFAULT_REASON = 'AI-generated ad creative';

export const aiContentLabelSchema = z.object({
  required: z.boolean(),
  reason: z.string().trim().max(200).nullable(),
});
export type AiContentLabel = z.infer<typeof aiContentLabelSchema>;

/// Etiketin dayanağı — yayın yolu kaydına ve teşhise.
export type AiContentLabelSource = 'flag' | 'production' | 'generated' | 'uploaded';

export interface AiContentLabelResult extends AiContentLabel {
  source: AiContentLabelSource;
}

/// Kreatif satırının okunan alanları — Prisma satırı da görünüm de uyar.
export interface AiContentLabelCreative {
  type: string;
  productionId?: string | null;
  inputParams?: unknown;
}

function flagOf(inputParams: unknown): { required: boolean; reason: string | null } | null {
  if (typeof inputParams !== 'object' || inputParams === null || Array.isArray(inputParams)) {
    return null;
  }
  const raw = (inputParams as Record<string, unknown>)[AI_CONTENT_LABEL_KEY];
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return null;
  const record = raw as Record<string, unknown>;
  if (typeof record.required !== 'boolean') return null;
  const reason =
    typeof record.reason === 'string' && record.reason.trim()
      ? record.reason.trim().slice(0, 200)
      : null;
  return { required: record.required, reason };
}

/**
 * Bu kreatif yayında AI içerik etiketi taşımalı mı — tek kural (dosya başı).
 * Yayın yolu `required` ise platformun AI beyanını AÇAR; gerekçe yalnız kayıt
 * ve teşhis için (platforma gönderilmez).
 */
export function aiContentLabelOf(creative: AiContentLabelCreative): AiContentLabelResult {
  const flag = flagOf(creative.inputParams);
  if (flag?.required) return { required: true, reason: flag.reason, source: 'flag' };
  if (creative.productionId) {
    return {
      required: true,
      reason: flag?.reason ?? AI_CONTENT_LABEL_DEFAULT_REASON,
      source: 'production',
    };
  }
  if (!isUploadedCreativeType(creative.type)) {
    return { required: true, reason: AI_CONTENT_LABEL_DEFAULT_REASON, source: 'generated' };
  }
  return { required: false, reason: null, source: 'uploaded' };
}
